// Small helper to assign stable client-side IDs to list items whose model
// doesn't provide one (e.g. AI-generated cards for attrezzature, sostanze, ecc).
// Uses crypto.randomUUID when available; falls back to a compact pseudo-random.
export function uid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `k-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

// Return a stable key for a list item — uses the item's `_uid` if present,
// or synthesizes one from a semantic field (code/name/id) + index as a fallback.
export function stableKey(item, index, semanticFields = ["_uid", "id", "codice", "code", "nome", "name"]) {
  if (item && typeof item === "object") {
    for (const f of semanticFields) {
      if (item[f]) return `${f}:${item[f]}`;
    }
  }
  return `idx:${index}`;
}
